import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";
import { AppContext } from "../../scripts/context";
import Footer from "./Footer";
import MainHeader from "./Header";
import UpdateNetWorkPage from "../../components/UpdateNetWorkPage";
import DisconnectedWallet from "../../components/DisconnectedWallet";
const Layout = () => {
  const { state, isNetwork } = useContext(AppContext);
  return (
    <>
      {state?.user?.address ? (
        isNetwork ? (
          <Outlet />
        ) : (
          <Container fluid>
            <MainHeader />
            <UpdateNetWorkPage />
            <Footer />
          </Container>
        )
      ) : (
        <Container fluid>
          <MainHeader />
          <DisconnectedWallet />
          <Footer />
        </Container>
      )}
      <div
        id="background-radial-gradient"
        className="background-radial-gradient1"
      ></div>
    </>
  );
};

export default Layout;
